<div
  class="more-info body-bold"
  [class]="variant()"
  [class.grouped]="grouped()"
  [class.blackBg]="blackBg()"
  [class.disabled]="disabled()"
>
  @if (svgIcon()) {
    <i
      nz-icon
      [nzType]="svgIcon()"
      class="svg-icon"
      [class.fillwhite]="fillWhite()"
    ></i>
  }
  <span><ng-content></ng-content></span>
  @if (svgIconRight()) {
    <nz-icon
      [nzType]="svgIconRight()"
      [class.fillwhite]="fillWhite()"
      nzTheme="outline"
    />
  }
</div>
